export const DELAY_TEXT_FILTER = 500; // milisegundos

// MENÚ PRINCIPAL
const COMPROMETIDOS = {
  key: "ion-comprometidos",
  label: "ION Comprometidos",
  accessProperty: "ION",
};
const GASTOS = {
  key: "gastos",
  label: "Gastos",
  accessProperty: "Movimientos",
};
const PREFACTURAS = {
  key: "prefacturas",
  label: "Prefacturas",
  accessProperty: "Prefacturas",
};
const AUTORIZACIONES = {
  key: "autorizaciones",
  label: "Autorizaciones",
  accessProperty: "Autorizacion_Prefacturas",
};
export const INFORMES = {
  key: "informes",
  label: "Informes",
  accessProperty: "Informes",
};
export const MENUS = [COMPROMETIDOS, GASTOS, PREFACTURAS, AUTORIZACIONES];

const AREAS = {
  key: "areas",
  label: "ÁREAS Prefacturas",
  accessProperty: "Areas",
};
const AREAS_ION = {
  key: "areas_ion",
  label: "ÁREAS Ion",
  accessProperty: "IONAreas",
};
const PROVEEDORES = {
  key: "proveedores",
  label: "PROVEEDORES",
  accessProperty: "Proveedores",
};
const PARTIDAS = {
  key: "partidas",
  label: "PARTIDAS",
  accessProperty: "IONPartidas",
};
const USUARIOS = {
  key: "usuarios",
  label: "USUARIOS",
  accessProperty: "Usuarios",
};
const ROLES = {
  key: "roles",
  label: "ROLES",
  accessProperty: "Roles",
};
const GLOSARIO_PARTIDAS = {
  key: "glosario_partidas",
  label: "GLOSARIO PARTIDAS",
  accessProperty: "Prefacturas",
};
export const MENUS_EXTRA = [
  AREAS,
  AREAS_ION,
  PROVEEDORES,
  PARTIDAS,
  USUARIOS,
  ROLES,
  GLOSARIO_PARTIDAS
];

// COMPROMETIDOS
export const METADATA_CREAR_COMPROMETIDO = [
  //Necesarios
  {
    nombreCampo: "TipoCarga",
    etiqueta: "Tipo Carga",
    tipo: "list",
    nombreLista: "TipoCarga",
    requerido: true,
  },

  {
    nombreCampo: "Gestor",
    etiqueta: "Gestor",
    tipo: "text",
    requerido: true,
  },
  {
    nombreCampo: "IDPrinex",
    etiqueta: "Id. Prinex",
    tipo: "text",
    requerido: false,
    campoDependiente: "TipoCarga",
  },
  {
    nombreCampo: "CodigoPromocion",
    etiqueta: "Código Promoción",
    tipo: "text",
    requerido: true,
  },
  {
    nombreCampo: "Sociedad",
    etiqueta: "Sociedad",
    tipo: "list",
    nombreLista: "SociedadAuxiliar",
    requerido: true,
  },
  {
    nombreCampo: "CodigoSociedad",
    etiqueta: "Código Sociedad",
    tipo: "text",
    readOnly: true,
  },
  {
    nombreCampo: "Familia",
    etiqueta: "Familia",
    tipo: "list",
    nombreLista: "Familia",
    listaRelacional: "Concepto",
    requerido: true,
  },
  {
    nombreCampo: "Concepto",
    etiqueta: "Concepto",
    nombreLista: "Concepto",
    tipo: "list",
    requerido: true,
    campoDependiente: "Familia",
  },
  {
    nombreCampo: "Importe",
    etiqueta: "Importe",
    tipo: "float",
    requerido: true,
  },
  {
    nombreCampo: "Proveedor",
    etiqueta: "Proveedor",
    tipo: "relate",
    nombreLista: "ProveedoresION",
    requerido: true,
    parent: "Area",
  },
  {
    nombreCampo: "CodigoProveedor",
    etiqueta: "Código Proveedor",
    tipo: "text",
    readOnly: true,
  },
  {
    nombreCampo: "AreaProveedor",
    etiqueta: "Área Proveedor",
    tipo: "list",
    nombreLista: "AreaProveedor",
    editable: true,
    requerido: false,
  },
  {
    nombreCampo: "FechaComprometido",
    etiqueta: "Fecha Comprometido",
    tipo: "date",
    requerido: true,
  },
  {
    nombreCampo: "TipoFacturable",
    etiqueta: "Tipo Facturable",
    tipo: "list",
    nombreLista: "TipoFacturable",
    requerido: true,
  },

  {
    nombreCampo: "Validar",
    etiqueta: "Validar",
    tipo: "checkbox",
    requerido: false,
  },
  {
    nombreCampo: "PagoAnticipa",
    etiqueta: "Pago Anticipado",
    tipo: "checkbox",
    requerido: false,
    defaultValue: false,
  },
   {
    nombreCampo: "Prorrateo",
    etiqueta: "Prorrateo",
    tipo: "checkbox",
    requerido: false,
    defaultValue: false,
  },
  {
    nombreCampo: "RGO",
    etiqueta: "RGO",
    tipo: "float",
  },
  {
    nombreCampo: "RGOUltimaCertificacion",
    etiqueta: "RGO Última Certificación",
    tipo: "checkbox",
  },
  {
    nombreCampo: "AbonarOT",
    etiqueta: "Abonar OT",
    tipo: "text",
  },
  {
    nombreCampo: "FechaEjecucion",
    etiqueta: "Fecha Ejecución",
    tipo: "date",
  },
  {
    nombreCampo: "FechaFinalizacion",
    etiqueta: "Fecha Finalización",
    tipo: "date",
  },
  {
    nombreCampo: "NumeroServicio",
    etiqueta: "Número Servicio",
    tipo: "text",
  },
  {
    nombreCampo: "TipoActuacion",
    etiqueta: "Tipo Actuación",
    tipo: "text",
  },
  {
    nombreCampo: "NumeroServicioIncidencia",
    etiqueta: "Número Servicio Incidencia",
    tipo: "text",
  },
  {
    nombreCampo: "EstadoServicio",
    etiqueta: "Estado Servicio",
    tipo: "text",
  },
  {
    nombreCampo: "NumeroExpediente",
    etiqueta: "Número Expediente",
    tipo: "text",
  },
  {
    nombreCampo: "OrigenPosesion",
    etiqueta: "Origen Posesión",
    tipo: "text",
  },
  {
    nombreCampo: "FechaInicioProrrateo",
    etiqueta: "Fecha Inicio Prorrateo",
    tipo: "date",
    editable: true,
  },
  {
    nombreCampo: "MesesProrrateo",
    etiqueta: "Meses Prorrateo",
    tipo: "int",
    editable: true,
  },
  {
    nombreCampo: "Observaciones",
    etiqueta: "Observaciones",
    tipo: "text",
    colSpan: 3
  },
];

export const METADATA_VISUALIZAR_EDITAR_COMPROMETIDO = [
  {
    nombreCampo: "Ot",
    etiqueta: "Ot",
    tipo: "text",
  },
  {
    nombreCampo: "OtArea",
    etiqueta: "Ot Area",
    tipo: "text",
  },
  {
    nombreCampo: "TipoCarga",
    etiqueta: "Tipo Carga",
    tipo: "text",
  },
  {
    nombreCampo: "Gestor",
    etiqueta: "Gestor",
    tipo: "text",
  },
  {
    nombreCampo: "IDPrinex",
    etiqueta: "Id. Prinex",
    tipo: "text",
    campoDependiente: "TipoCarga",
  },

  {
    nombreCampo: "Sociedad",
    etiqueta: "Sociedad",
    tipo: "text",
  },
  {
    nombreCampo: "CodigoSociedad",
    etiqueta: "Código Sociedad",
    tipo: "text",
  },
  {
    nombreCampo: "CodigoPromocion",
    etiqueta: "Código Promoción",
    tipo: "text",
  },
  {
    nombreCampo: "Familia",
    etiqueta: "Familia",
    tipo: "text",
  },
  {
    nombreCampo: "Concepto",
    etiqueta: "Concepto",
    tipo: "text",
  },

  {
    nombreCampo: "FechaComprometido",
    etiqueta: "Fecha Comprometido",
    tipo: "date",
  },
  {
    nombreCampo: "AbonarOT",
    etiqueta: "Abonar OT",
    tipo: "text",
  },
  {
    nombreCampo: "FechaEjecucion",
    etiqueta: "Fecha Ejecución",
    tipo: "date",
  },
  {
    nombreCampo: "FechaFinalizacion",
    etiqueta: "Fecha Finalización",
    tipo: "date",
  },
  {
    nombreCampo: "TipoActuacion",
    etiqueta: "Tipo Actuación",
    tipo: "text",
  },
  {
    nombreCampo: "OrigenPosesion",
    etiqueta: "Origen Posesión",
    tipo: "text",
  },

  {
    nombreCampo: "IdUnico",
    etiqueta: "Id. Único",
    tipo: "text",
  },
  {
    nombreCampo: "Partida",
    etiqueta: "Partida",
    tipo: "text",
  },
  {
    nombreCampo: "NombrePartida",
    etiqueta: "Nombre Partida",
    tipo: "text",
    colSpan: 2
  },
  {
    nombreCampo: "FechaCreacionComprometido",
    etiqueta: "Fecha Creación Comprometido",
    tipo: "date",
  },
  {
    nombreCampo: "Exportado",
    etiqueta: "Exportado",
    tipo: "text",
  },
  {
    nombreCampo: "FechaFacturable",
    etiqueta: "Fecha Facturable",
    tipo: "date",
  },
  {
    nombreCampo: "CodigoPrefactura",
    etiqueta: "Código Prefactura",
    tipo: "text",
  },
  {
    nombreCampo: "FicheroOrigen",
    etiqueta: "Fichero Origen",
    tipo: "text",
  },
  {
    nombreCampo: "Prorrateo",
    etiqueta: "Prorrateo",
    tipo: "text",
  },
  {
    nombreCampo: "EstadoTrazabilidaInversa",
    etiqueta: "Estado Trazabilidad Inversa",
    tipo: "text",
  },
  {
    nombreCampo: "Importe",
    etiqueta: "Importe",
    tipo: "float",
    editable: false,
  },
  {
    nombreCampo: "ImporteRevisado",
    etiqueta: "Importe Revisado",
    tipo: "float",
    editable: true,
    requerido: true,
  },
  {
    nombreCampo: "TipoFacturable",
    etiqueta: "Tipo Facturable",
    tipo: "list",
    nombreLista: "TipoFacturable",
    editable: true,
    requerido: true,
  },
  {
    nombreCampo: "Proveedor",
    etiqueta: "Proveedor",
    tipo: "relate",
    nombreLista: "ProveedoresION",
    editable: true,
    requerido: true,
    parent: "Area",
  },
  {
    nombreCampo: "CodigoProveedor",
    etiqueta: "Código Proveedor",
    tipo: "text",
    readOnly: true,
  },
  {
    nombreCampo: "Validar",
    etiqueta: "Validar",
    tipo: "checkbox",
    editable: true,
  },
  {
    nombreCampo: "PagoAnticipa",
    etiqueta: "Pago Anticipado",
    tipo: "checkbox",
    editable: false,
  },
  {
    nombreCampo: "RGO",
    etiqueta: "RGO",
    tipo: "float",
    editable: true,
  },
  {
    nombreCampo: "RGOUltimaCertificacion",
    etiqueta: "RGO Última Certificación",
    tipo: "checkbox",
    editable: true,
  },
  {
    nombreCampo: "AreaProveedor",
    etiqueta: "Área Proveedor",
    tipo: "list",
    nombreLista: "AreaProveedor",
    editable: true,
    requerido: false,
  },
  {
    nombreCampo: "NumeroServicio",
    etiqueta: "Número Servicio",
    tipo: "text",
    editable: true,
  },
  {
    nombreCampo: "NumeroServicioIncidencia",
    etiqueta: "Número Servicio Incidencia",
    tipo: "text",
    editable: true,
  },
  {
    nombreCampo: "EstadoServicio",
    etiqueta: "Estado Servicio",
    tipo: "text",
    editable: true,
  },
  {
    nombreCampo: "NumeroExpediente",
    etiqueta: "Número Expediente",
    tipo: "text",
    editable: true,
  },
  {
    nombreCampo: "FechaInicioProrrateo",
    etiqueta: "Fecha Inicio Prorrateo",
    tipo: "date",
    editable: true,
  },
  {
    nombreCampo: "MesesProrrateo",
    etiqueta: "Meses Prorrateo",
    tipo: "int",
    editable: true,
  },
  {
    nombreCampo: "ImporteProrrateado",
    etiqueta: "Importe Prorrateado",
    tipo: "float",
    editable: false,
  },
  {
    nombreCampo: "Observaciones",
    etiqueta: "Observaciones",
    tipo: "text",
    editable: true,
    colSpan: 3
  },
];

// MOVIMIENTOS
export const MOVIMIENTOS_POR_PAGINA = 20;

// PREFACTURAS
export const PREFACTURAS_POR_PAGINA = 20;

export const METADATA_TABLE_COMENTARIOS = [
  {
    nombreCampo: "fecha",
    etiqueta: "Fecha",
    tipo: "datetime",
  },
  {
    nombreCampo: "usuario",
    etiqueta: "Usuario",
    tipo: "text",
  },
  {
    nombreCampo: "comentario",
    etiqueta: "Comentario",
    tipo: "text",
  },
];

export const ESTADOS_PREFACTURA = {
  ANULADA: 0,
  CREADA: 1,
  POR_VALIDAR: 5,
  POR_VALIDAR_PROVEEDOR: 6,
  VALIDADA_PARCIAL: 8,
  VALIDADA: 10,
  ONBASE: 15,
  AUTORIZACION_ELIMINACION: 20,
};

// AUTORIZACIONES
export const AUTORIZACIONES_POR_PAGINA = 20;

// AREAS
export const AREAS_POR_PAGINA = 20;

// PROVEEDORES
export const PROVEEDORES_POR_PAGINA = 20;

// PROVEEDORES
export const PARTIDAS_POR_PAGINA = 20;

// AUDITORIA
export const AUDITORIAS_POR_PAGINA = 20;

// USUARIOS
export const USUARIOS_POR_PAGINA = 20;

// PALETA DE COLORES
export const COLORES = {
  //LOADING
  LOADING_BACKGROUND: "#0003",
  BACKGROUND: "white",
  BORDER: "grey",
  LIGHT_BORDER: "lightgrey",
  MENU_BACKGROUND: process.env.REACT_APP_BAR_COLOR,
  MENU_HOVER: "#ffd0d0",
  MENU_ACTIVE: "indianred",
  LOADING_TEXT: "indianred",
  BLACK: "black",
  LIST_ACTIVE: "indianred",
  LIST_HOVER: "#ffd0d0",
  LINK: "blue",
  TEXT_DISABLED: "grey",
  BACKGROUND_DISABLED: "lightgrey",
  HIGHLIGHTED: "#cee7ff",
  DELETED: "#dd0000",
  DIALOG_COMMENT: "royalblue",
  FORWARD: "green",
  BACKWARD: "red",
  EXPORT: "#2588bb",
  BUTTON_TEXT_DEFAULT: "white",
  BUTTON_BACKGROUND_DEFAULT: "#66aaff",
  HEADER_TABLE_FONT: "white",
  HEADER_TABLE_BACKGROUND: "#0770a7",
  HEADER_TAB: "#44546A",
  HEADER_CARET_TAB: "#c3c3c3",
  MODAL_TITLE : "#374151",
  MODAL_TITLE_BG : "#F9FAFB",
  MODAL_TITLE_LINE: "#E5E7EB"
};

export const formatDate = (date) => {
  const auxArray = date.split("T")[0].split("-");
  const year = auxArray[0];
  const month = auxArray[1];
  const day = auxArray[2];
  return day + "/" + month + "/" + year;
};
